import { LitEntity, html } from '../../utility/lit-entity';
import { BnModalMixin } from '../../common/bn-modal-mixin';
import '../../common/bn-action';
import '../../common/bn-flash';
import { sharedStyles } from '../../styles/shared-styles';

class BinDimensionConfirmModal extends BnModalMixin(LitEntity) {
  constructor() {
    super();
    this.id = 'bin-dimension-confirm-modal';
    this.messages = '';
  }

  static get properties() {
    return {
      actionHref: { type: String, attribute: false },
      message: { type: String, attribute: false },
    };
  }

  renderContents() {
    return html`
      <style>
      ${sharedStyles}
        bn-modal#bin-dimension-confirm-modal {
          --modal-min-width: 55%;
          --modal-max-width: 70%;
        }
        h3 {
          margin: 0;
        }
        p {
          font-size: 1.12em;
          margin-top: 0;
        }
        div {
          margin-top: 0;
        }
      </style>
      
      <h3 slot="title">Confirm Input</h3>
      <bn-flash id="status"></bn-flash>
      <div>
        <p>Are you sure you want to input these values?</p>
        <div>${this._renderMessage()}</div>
        <button class="button button--contained" @click="${this._onConfirm}">Confirm</button>
        <button class="button button--outlined" @click="${this._onCancel}">Edit</button>
      </div>
    `;
  }

  _renderMessage() {
    if (!this.message) {
      return '';
    }

    const lines = this.message.trim().split('\n');
    return html`
      <ul>
        ${lines.map(line => html`<li>${line}</li>`)}
      </ul>
    `;
  }

  _onConfirm() {
    this.dispatchEvent(new CustomEvent('confirm'));
  }

  _onCancel() {
    this.dispatchEvent(new CustomEvent('cancel'));
  }
}

customElements.define('bin-dimension-confirm-modal', BinDimensionConfirmModal);
